<template>
    <div>
      <a-card>
        <template slot="title">
          <span>Claim Ticket Report Recapitulation</span>
        </template>
        <a-row class="m-width-full" :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <a-month-picker
              v-model="filter.transaction_date"
              :disabled="loading.tab"
              placeholder="Search By Periode" format="MMMM-YYYY"
              :class="getScreen ? 'margin-top' : ''"
            />
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <a-select placeholder="Search By Assignee" class="m-width-full"
              v-model="filter.karyawan" 
              :disabled="loading.tab"
              :filterOption="filterOption"
              showSearch allowClear
              :class="getScreen ? 'margin-top' : ''"
              >
              <a-select-option
                v-for="karyawan in getAllKaryawan"
                :key="karyawan.tlc"
              >{{karyawan.tlc}} - {{karyawan.nama}}</a-select-option> 
            </a-select>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-input-search
              v-model="filter.search"
              :disabled="loading.tab"
              @input="onQuickSearch"
              placeholder="Quick Search ..."
              :class="getScreen ? 'margin-top' : ''"
            />
          </a-col>
        </a-row>
      </a-card>
      <a-tabs defaultActiveKey="need process" :activeKey="source.tabActive" type="card" class="mcr-tab" @change="callbackTab">
        <a-tab-pane v-if="isHRD" :tab="'Process List'" key="need process">
          <a-table
            :rowKey="(record, index) => {return index;}"
            :columns="columnsProcess"
            :dataSource="source.listProcess"
            :pagination="pagination"
            :loading="loading.tab"
            size="small"
            class="table-tab"
            :scroll="{ x: 400 }"
            bordered
          >
            <template slot="title">
              <div class="m-display-flex space-end">Selected: {{selectedList.length}}</div>
            </template>
            <template slot="no" slot-scope="item,data,index">
              {{ index+1 }}
            </template>
            <template slot="no_klaim_cc_tiket" slot-scope="item">
              <a href="#" @click="gotoManifest(item)">{{ item.no_klaim_cc_tiket }}</a>
            </template>
            <template slot="tgl_klaim_cc_tiket" slot-scope="item">
              {{ moment(item.tgl_klaim_cc_tiket).format(getDefaultDateFormat) }} / {{ item.tlc }} / {{ moment(item.tgl_approve_cc_tiket).format(getDefaultDateFormat) }}
            </template>
            <template slot="no_cc" slot-scope="item">
              {{ item.no_cc }}
            </template>
            <template slot="qty_end_user" slot-scope="item">
              {{ item.qty_end_user }}
            </template>
            <template slot="total_claim" slot-scope="item">
              {{ formatCurrency('IDR',item.total_claim) }}
            </template>
            <template slot="action1" slot-scope="item" class="flex">
              <a-button type="primary" icon="eye" size="small" @click="showDtl(item)" :loading="loading.dtl && loading.key==item.new_id"/>
            </template>
            <template slot="customCheck">
              <a-checkbox v-model="checkedAll" @click="tocheckedAllinitial()" @change="(e)=>{synchCheckedAll(e.target)}"/>
            </template>
            <template slot="action2" slot-scope="item" class="flex">
              <a-checkbox v-model="item.checked" @change="(e)=>{synchCheckedtoOri(e.target.checked,item)}"/>
            </template>
            <template slot="footer" > 
              <div class="m-display-flex space-end">
                <a-button type="primary" class="m-padding-small" @click="processing">Process Recapitulation</a-button>
              </div>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane :tab="'Recapitulation List'" key="rekap list">
          <a-table
            :rowKey="(record, index) => {return index;}"
            :columns="columnsList"
            :dataSource="source.listRecap"
            :pagination="pagination2"
            :loading="loading.tab"
            size="small"
            class="table-tab"
            :scroll="{ x: 400 }"
            bordered
          >
            <template slot="title">
              <div class="m-display-flex space-end">Selected: {{selectedList.length}}</div>
            </template>
            <template slot="no" slot-scope="item,data,index">
              {{ index+1 }}
            </template>
            <template slot="claim_no" slot-scope="item">
              {{ item.no_rekap }}
            </template>
            <template slot="create_dt" slot-scope="item">
              {{ moment(item.create_dt).format(getDefaultDateFormat) }} / {{ item.tlc_create }}
            </template>
            <template slot="description" slot-scope="item">
              {{ item.description }}
            </template>
            <template slot="claim_total" slot-scope="item">
              {{ formatCurrency('IDR',item.total_value) }}
            </template>
            <template slot="action" slot-scope="item">
                <div style="display:flex;justify-content:center">
                  <a-tooltip placement="topRight">
                    <template slot="title">
                      <span>View</span>
                    </template>
                    <a-button icon="eye" type="default" :class="isHRD ? 'margin-right' : ''" @click="gotoManifest2(item)"></a-button>
                  </a-tooltip>
                  <div v-if="isHRD">
                    <a-button v-if="item.id_pp!=null" icon="delete" type="danger" :disabled="item.id_pp!=null"></a-button>
                    <a-tooltip v-else placement="topRight">
                      <template slot="title">
                        <span>Delete</span>
                      </template>
                      <a-popconfirm title="Are you sure？" placement="bottomRight" @confirm="handleDelete(item)" ok-text="Yes" cancel-text="No">
                        <a-icon slot="icon" type="question-circle-o" style="color: red" />
                        <a-button icon="delete" type="danger"></a-button>
                      </a-popconfirm>
                    </a-tooltip>
                  </div>
                </div>
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
  
      <DialogProcess 
        v-if="dialog.visible"
        :visible="dialog.visible"
        :selectedData="selectedList"
      />
  
      <DialogDetil
        v-if="dialog.visibleDtl"
        :visible="dialog.visibleDtl"
        :dtl="dialog.dataDtl"
      />
    </div>
  </template>
  <script>
  import { mapGetters } from "vuex";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import DialogProcess from "./DialogProcess.vue";
  import DialogDetil from "./DialogDetil.vue";
  import GlobalMethod from "@/mixins/GlobalMethod.js";
  import moment from "moment";
  import CryptoJS from "crypto-js";
  import _ from "lodash";
  
  export default {
    name: "ListMonitoringKlaimTiket",
    mixins: [CurrencyFormat, GlobalMethod],
    components:{DialogProcess, DialogDetil},
    data() {
        const columnsProcess = [
            {
                title: "#",
                dataIndex: "no",
                key: "no",
                width: "55px",
                align: "right",
                scopedSlots: { customRender: "no" },
                sorter: (a, b) => a.no - b.no,
            },
            {
                title: "Created Date / TLC / Approved Date",
                key: "tgl_klaim_cc_tiket",
                width: "150px",
                align: "center",
                scopedSlots: { customRender: "tgl_klaim_cc_tiket" },
                sorter: (a, b) => a.tgl_klaim_cc_tiket - b.tgl_klaim_cc_tiket,
            },
            {
                title: "Claim No",
                key: "no_klaim_cc_tiket",
                width: "200px",
                align: "center",
                scopedSlots: { customRender: "no_klaim_cc_tiket" },
                sorter: (a, b) => a.no_klaim_cc_tiket - b.no_klaim_cc_tiket,
            },
            {
                title: "Credit Card No",
                key: "no_cc",
                align: "center",
                scopedSlots: { customRender: "no_cc" },
                sorter: (a, b) => a.no_cc - b.no_cc,
            },
            {
                title: "Qty End User",
                key: "qty_end_user",
                width: "100px",
                align: "center",
                scopedSlots: { customRender: "qty_end_user" },
                sorter: (a, b) => a.qty_end_user - b.qty_end_user,
            },
            {
                title: "Total Claim",
                key: "total_claim",
                width: "180px",
                align: "right",
                scopedSlots: { customRender: "total_claim" },
                sorter: (a, b) => a.total_claim - b.total_claim,
            },
            {
                title: "Action",
                key: "action",
                align: "center",
                fixed: "right",
                children: [
                {
                    key: 'action1',
                    title: "#",
                    width: "40px",
                    align: "center",
                    scopedSlots: { customRender: "action1" },
                },
                {
                    key: 'action2',
                    slots: { title: 'customCheck' },
                    width: "40px",
                    align: "center",
                    scopedSlots: { customRender: "action2" },
                },
                ]
            },
        ];
  
      const columnsList = [
        {
          title: "#",
          dataIndex: "no",
          key: "no",
          width: "70px",
          align: "right",
          scopedSlots: { customRender: "no" },
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Recapitulation Claim No",
          key: "claim_no",
          width: "200px",
          align: "center",
          scopedSlots: { customRender: "claim_no" },
          sorter: (a, b) => a.no_rekap - b.no_rekap,
        },
        {
          title: "Created Date / TLC",
          key: "create_dt",
          width: "200px",
          align: "center",
          scopedSlots: { customRender: "create_dt" },
          sorter: (a, b) => a.create_dt - b.create_dt,
        },
        {
          title: "Description",
          key: "description",
          align: "left",
          scopedSlots: { customRender: "description" },
          sorter: (a, b) => a.description - b.description,
        },
        {
          title: "Total Recapitulation Claim",
          key: "claim_total",
          width: "230px",
          align: "right",
          scopedSlots: { customRender: "claim_total" },
          sorter: (a, b) => a.total_value - b.total_value,
        },
        {
          title: "Action",
          key: "action",
          width: 100,
          align: "center",
          scopedSlots: { customRender: "action" },
          fixed: "right"
        },
      ];
  
      return {
        columnsProcess,
        columnsList,
        source: {
          tabActive: "need process",
          listProcess: [],
          listProcessOri: [],
          listRecap: [],
          listRecapOri: []
        },
        loading: {
          tab: false,
          timequicksearch: null,
          quicksearch: false,
          dtl: false,
          key: ""
        },
        pagination: {
          onChange: (page) => {},
          pageSize: 10,
          size: "small",
        },
        pagination2: {
          onChange: (page) => {},
          pageSize: 10,
          size: "small",
        },
        filter: {
          search: null,
          transaction_date: null,
          karyawan: undefined
        },
        dialog:{
          visible: false,
          visibleDtl: false,
          dataDtl: [],
        },
        checkedAll: false,
        checkedAllinitial: true
      }
    },
    computed: {
      ...mapGetters([
        "getAuth",
        "getScreen",
        "getAllKaryawan",
        "getStandartFormatDate",
        "getDefaultDateFormat",
        "getDateTimeStandartFormat"
      ]),
      selectedList(){
        return this.source.listProcess.filter(item=>item.checked==true)
      },
      isHRD(){
        let res = false
        this.getAuth.divisi.forEach(element => {
          if(element.toLowerCase()=='hrd'){
            res = true
          }
        });
        return res
      },
    },
    created() {
      this.$store.dispatch("FETCH_ALL_KARYAWAN");
      Event.$on("closeDiagProc", this.closeDialogProcess);
      Event.$on("closeDiagDtl", this.closeDialogDtl);
      Event.$on("fetchTab", this.fetch);
    },
    beforeDestroy() {
      Event.$off("closeDiagProc", this.closeDialogProcess);
      Event.$off("closeDiagDtl", this.closeDialogDtl);
      Event.$off("fetchTab", this.fetch);
    },
    mounted(){
      if(!this.isHRD){
        this.source.tabActive = "rekap list";
      }
  
      this.fetch()
    },
    methods:{
      moment,
      fetch(){
        this.loading.tab = true
        this.asyncAxiosGet("rekap_tiket",
          this.getAuth,
          {
            tab: this.source.tabActive
          }
        ).then((res) => {
          if(this.source.tabActive=="need process"){
            if(res.data)
              res.data.forEach(element => {
                element['checked'] = false
              });
  
            this.source.listProcess = res.data ? res.data : []
            this.source.listProcessOri = res.data ? res.data : []
          }else{
            this.source.listRecap = res.data ? res.data : []
            this.source.listRecapOri = res.data ? res.data : []
          }
        
          this.loading.tab = false
        }).catch((err) => {
          this.loading.tab = false
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        });
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
      },
      callbackTab(val){
        this.source.tabActive = val
        this.fetch()
      },
      onSearch(){
        this.loading.tab = true
        let dataSource = []

        if(this.source.tabActive=='need process'){
          dataSource = this.source.listProcessOri
          if(this.filter.transaction_date){
            let startDt = moment(this.filter.transaction_date).subtract(1, 'month').set('date', 16);
            let endDt = moment(startDt).add(1, 'month').set('date', 15);
  
            dataSource = dataSource.filter(item => 
              (moment(item.tgl_klaim_cc_tiket).format(this.getStandartFormatDate) >= moment(startDt).format(this.getStandartFormatDate) &&
              moment(item.tgl_approve_cc_tiket).format(this.getStandartFormatDate) <= moment(endDt).format(this.getStandartFormatDate))
              || Number(item.checked)>0)
  
            this.checkedAll = false //untuk reset checkbox all
          }
          if(this.filter.karyawan)
            dataSource = dataSource.filter(item => item.tlc == this.filter.karyawan || Number(item.checked)>0)
          if(this.filter.search)
            dataSource = dataSource.filter(item => 
              (item.no_klaim_cc_tiket && item.no_klaim_cc_tiket.toLowerCase().indexOf(this.filter.search.toLowerCase())>=0) ||
              (item.no_cc && item.no_cc.toLowerCase().indexOf(this.filter.search.toLowerCase())>=0) ||
              (item.type_cc && item.type_cc.toLowerCase().indexOf(this.filter.search.toLowerCase())>=0) ||
              (item.total_claim && item.total_claim.toLowerCase().indexOf(this.filter.search.toLowerCase())>=0) || Number(item.checked)>0
            )
          this.source.listProcess = dataSource
        }else{
          dataSource = this.source.listRecapOri
          if(this.filter.transaction_date){
            let startDt = moment(this.filter.transaction_date).set('date', 16);
            let endDt = moment(startDt).add(1, 'month').set('date', 15);
  
            dataSource = dataSource.filter(item => 
              (moment(item.create_dt).format(this.getStandartFormatDate) >= moment(startDt).format(this.getStandartFormatDate) &&
              moment(item.create_dt).format(this.getStandartFormatDate) <= moment(endDt).format(this.getStandartFormatDate)))
          }
          if(this.filter.karyawan)
            dataSource = dataSource.filter(item => item.tlc_create == this.filter.karyawan || Number(item.checked)>0)
          if(this.filter.search)
            dataSource = dataSource.filter(item => 
              item.no_rekap.toLowerCase().indexOf(this.filter.search.toLowerCase())>=0 ||
              item.description.toLowerCase().indexOf(this.filter.search.toLowerCase())>=0 || Number(item.checked)>0
            )
          this.source.listRecap = dataSource
        }
        this.loading.tab = false
      },
      onQuickSearch(){
        if (this.loading.timequicksearch) {
          clearTimeout(this.loading.timequicksearch);
        }
          this.loading.timequicksearch = setTimeout(() => {
            this.onSearch();
        }, 500);
      },
      closeDialogProcess(){
        this.dialog.visible = false
      },
      closeDialogDtl(){
        this.dialog.visibleDtl = false
      },
      processing(){
        if(this.selectedList.length==0){
          this.displayMessageValue("basic-warning", 'No data selected, please choose it!');
        }else{
          this.dialog.visible = true
        }
      },
      handleDelete(params){
        this.loading.tab = true;
        let data = new FormData();
        data.append("id_rekap_cc_tiket", params.id_rekap_cc_tiket);
        this.asyncAxiosPost("rekap_tiket/cancel", "formdata", this.getAuth, data)
        .then(() => {
          this.displayMessage("success-del");
          this.fetch()
        })
        .catch((err) => {
          this.loading.tab = false;
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        });
      },
      synchCheckedtoOri(val, params){
        this.source.listProcessOri.forEach(element => {
          if(element.id_klaim_cc_tiket==params.id_klaim_cc_tiket)
            element.checked = val
        });
  
        this.source.listProcessOri = _.orderBy(this.source.listProcessOri, [function (o) {return Number(o.checked);}, 'create_dt'], ['desc','asc'])
        this.onSearch()
      },
      tocheckedAllinitial(){
        this.checkedAllinitial = true
      },
      synchCheckedAll(val){
        if(this.checkedAllinitial){
          let temp = [...this.source.listProcess]
          temp.forEach(el1 => {
            this.source.listProcessOri.forEach(element => {
              if(element.id_klaim_cc_tiket==el1.id_klaim_cc_tiket){
                element.checked = val.checked;
                return false;
              }
            });
          })
          this.checkedAllinitial = false
          this.onSearch()
        }
      },
      gotoManifest(params){
        const route = this.$router.resolve({
              name: "manifest_klaim_tiket_hrd",
              params: {
                id: params.id_klaim_cc_tiket
              },
            });
            window.open(route.href, "_blank");
      },
      gotoManifest2(params){
        this.$router.push({ name: "rekapKlaimTiketManifest", params: { id: params.id_rekap_cc_tiket} });
      },
      gotoHarmoni(item){
        console.log(item)
        let params = {
          usr: this.getAuth.username,
          psw: this.getAuth.password,
          id: item.id_rekap_cc_tiket,
          page: "rekapKlaimTiketManifest",
          exp: moment().add(10, 'seconds').format(this.getDateTimeStandartFormat)
        }
  
        let id = CryptoJS.AES.encrypt(
        JSON.stringify(params)
        ,"IAO-key").toString()
  
        window.open(`${process.env.VUE_APP_HARMONI}referralFrom/${encodeURIComponent(id)}`, "_blank");
      },
      async showDtl(item){
        this.loading.dtl = true
        this.loading.key = item.id_klaim_cc_tiket
        await this.asyncAxiosGet("rekap_tiket/detail", this.getAuth, {
            id_klaim_cc_tiket: item.id_klaim_cc_tiket
        })
        .then((res) => {
          this.loading.dtl = false
          this.dialog.dataDtl = res
          this.dialog.visibleDtl = true
        })
        .catch(() => {
          this.loading.dtl = false
        });
      }
    },
    watch:{
      "filter.transaction_date"(){
        this.onSearch()
      },
      "filter.karyawan"(){
        this.onSearch()
      }
    }
  }
  </script>
  <style lang="less">
  .mcr-tab{
    .ant-tabs-card-bar{
      margin:0px;
    }
  }
  .table-tab{
    th{
      text-align: center!important;
    }
  }
  </style>